import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	privateEmail: {
		id: 'servicedesk-customers-organization-common.table.customer-cell.user.private-email',
		defaultMessage: 'private email address',
		description: 'label displayed for private email address',
	},
	moreOrgs: {
		id: 'servicedesk-customers-organization-common.table.customer-cell.user.more-orgs',
		defaultMessage: '+ {moreCount}',
		description:
			'Placeholder to be shown for a tooltip when there are two many organisation names to render with a {moreCount} argument to show the additional number of orgs',
	},
});
